import React from "react";
import pipe from "@insightfulscience/shared-utils/fn/pipe";
import contentfulStandardApp, { fetchProps } from "@insightfulscience/contentful/Apps/Standard";
import VisualCopyBlock from "@insightfulscience/contentful/Apps/components/VisualCopyBlock";
import { useLocale, WithLocale } from "@insightfulscience/i18";
import PageMeta from "@insightfulscience/smart-react/PageMeta";
import SiteLayout from "../../SiteLayout";
import SectionTryForFree from "../../SectionTryForFree";
import BlockLinks from "../../contentful/Apps/components/BlockLinks";
import HeroBlock from "../../contentful/Apps/Standard/components/HeroBlock";
import Page from "../../contentful/Apps/Standard/Page";
import resources from "../../../locales";
import { contentfulProps } from "../../config";

const VisualCopyBlockComponent = ({ ...props }) => (
	<VisualCopyBlock isImageFrame={false} ctaStyleType="primary" {...props} />
);

const standardPageLayout = ({ children }) => {
	const [t] = useLocale("standard-pages");
	return (
		<SiteLayout>
			<PageMeta>
				<PageMeta.Twitter image={t("META_TWITTER_IMAGE")} isImageBaseUrl />
			</PageMeta>
			{children}
			<SectionTryForFree />
		</SiteLayout>
	);
};

const ContentfulStandardApp = contentfulStandardApp({
	Layout: pipe(standardPageLayout, WithLocale({ resources })),
	Page,
	contentfulProps,
	pageProps: {
		resources,
		brandCode: "gn",
		siteDomain: "https://www.geneious.com",
		components: {
			linksBlock: BlockLinks,
			heroBlock: HeroBlock,
			visualCopyBlock: VisualCopyBlockComponent,
		},
	},
	mode: "isr",
});

export const getStaticPaths = async () => ({
	paths: [],
	fallback: "blocking",
});

export const getStaticProps = async ({ params: { slug } }) => {
	const props = await fetchProps(contentfulProps, slug.join("/"), false);

	return props?.post
		? {
				props,
				revalidate: false,
		  }
		: { notFound: true };
};

export default ContentfulStandardApp;
